import { Table } from "antd";
import React, { useEffect, useState } from "react";
import { adminMainUrl } from "../../../Config";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllLedgerAccountIdAndPartyName,
  getAllMasterAccountLedgerGroupTypeIdAndName,
  getAllMasterBranchIdAndName,
  getAllMasterCashBookIdAndName,
  getAllMasterCurrencyIdAndName,
} from "../../../Redux/action/MasterAction";
import { useLocation, useNavigate } from "react-router-dom";
import { generateCode } from "../../../helper/autoGenId";
import { number } from "yup";

const VoucherProcessingReceiptVoucherEntryOne = ({ setActiveTab }) => {
  const token = Cookies.get("token");
  const user_id = Cookies.get("flexichain_user_id");

  const {
    MasterBranchName,
    MasterBranchNameError,
    loadingMasterBranchName,
    loadingMasterCashBookName,
    MasterCashBookName,
    MasterCashBookNameError,

    loadingLedgerAccountIdAndPartyName,
    LedgerAccountIdAndPartyName,
    LedgerAccountIdAndPartyNameError,

    loadingMasterCurrencyIdAndName,
    MasterCurrencyIdAndName,
    MasterCurrencyIdAndNameError,
  } = useSelector((state) => state?.MasterReducer);

  let initialValue = {
    voucher_id: "",
    voucher_number: "",
    voucher_date: "",
    branch: "",
    cost_centre: "",
    cash_book_id: "",
    current_balance: "",
    reference_number: "",
    ledger_account_id: "",
    gst_tin: "",
    state: "",
    currency: "",
    exchange_rate: "",
    fc_amount: "",
    amount: "",
    payment_by: "",
    payment_mode: "",
    chq_dd_no: "",
    chq_dd_date: "",

    reference_no: "",
    job_order: "", //docket
    shipper_name: "",
    bank_name: "",
    tds_rate: "",
    tds_account: "",
    tds_party: "",
    tds_amount: "",
    bank_charge: "",
    bank_amount: "",

    total_amount: "",
    total_tds_deducted: "",
    net_amount: "",

    narration: "",
    verified_by: "",
    date: "",
    book_total: "",
    total_tds: "",

    remittance_narration: "",
  }

  const [receiptVoucher, setReceiptVoucher] = useState(initialValue);

  // ── Summary calculation ───────────────────────────────────────
  // const totalAmount = Number(receiptVoucher.amount) || 0;
  // const totalTds = Number(receiptVoucher.tds_amount) || 0;
  // const netAmount = totalAmount - totalTds;

  const [isSubmitting, setIsSubmitting] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const location = useLocation();
  const urlString = window.location.href;
  const url = new URL(urlString);
  const path = url.pathname.slice(1);
  const searchParams = url.search;
  const q = path + searchParams;
  const queryParams = new URLSearchParams(location.search);

  const validateReceiptVoucher = () => {
    const errors = [];

    // ── Required fields ───────────────────────────────────────
    if (!receiptVoucher.voucher_date) {
      errors.push("Voucher Date is required");
    }

    if (!receiptVoucher.branch) {
      errors.push("Branch is required");
    }

    if (!receiptVoucher.cash_book_id) {
      errors.push("Cash Book is required");
    }

    if (!receiptVoucher.ledger_account_id) {
      errors.push("Ledger Account is required");
    }

    if (!receiptVoucher.currency) {
      errors.push("Currency is required");
    }

    // ── Amount validations ────────────────────────────────────
    if (!receiptVoucher.amount || isNaN(Number(receiptVoucher.amount))) {
      errors.push("Amount must be a valid number");
    } else if (Number(receiptVoucher.amount) <= 0) {
      errors.push("Amount must be greater than zero");
    }

    // Foreign currency related
    if (
      !receiptVoucher.exchange_rate ||
      isNaN(Number(receiptVoucher.exchange_rate)) ||
      Number(receiptVoucher.exchange_rate) <= 0
    ) {
      errors.push("Valid Exchange Rate is required for foreign currency");
    }
    if (
      !receiptVoucher.fc_amount ||
      isNaN(Number(receiptVoucher.fc_amount)) ||
      Number(receiptVoucher.fc_amount) <= 0
    ) {
      errors.push("Foreign Currency Amount is required");
    }
    // if (isForeignCurrency) {
    // }

    // TDS validation
    if (receiptVoucher.tds_amount) {
      const tds = Number(receiptVoucher.tds_amount);
      if (isNaN(tds) || tds < 0) {
        errors.push("TDS Amount cannot be negative");
      }
      if (tds > receiptVoucher.amount) {
        errors.push("TDS Amount cannot exceed Total Amount");
      }
    }

    // Optional but useful
    if (receiptVoucher.bank_charge && Number(receiptVoucher.bank_charge) < 0) {
      errors.push("Bank Charge cannot be negative");
    }

    if (errors.length > 0) {
      errors.forEach((err) => toast.error(err));
      return false;
    }

    return true;
  };

  const createReceiptVoucherApi = async () => {
    if (!validateReceiptVoucher()) return;

    const {
      voucher_number,
      voucher_id,
      voucher_date,
      branch,
      cost_centre,
      cash_book_id,
      current_balance,
      reference_number,
      ledger_account_id,
      gst_tin,
      state,
      currency,
      exchange_rate,
      fc_amount,
      amount,
      payment_by,
      payment_mode,
      chq_dd_no,
      chq_dd_date,

      reference_no,
      job_order, //docket
      shipper_name,
      bank_name,
      tds_rate,
      tds_account,
      tds_party,
      tds_amount,
      bank_charge,
      bank_amount,

      narration,
      verified_by,
      date,
      book_total,
      total_tds,

      total_amount,
      total_tds_deducted,
      net_amount,

      remittance_narration,
    } = receiptVoucher;
    try {
      setIsSubmitting(true);

      const response = await fetch(
        `${adminMainUrl}/api/account/receipt-voucher`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "auth-token": Cookies.get("token"),
            user_id: Cookies.get("flexichain_user_id"),
          },
          body: JSON.stringify({
            voucher_id,
            voucher_date,
            branch,
            cost_centre,
            cash_book_id,
            current_balance,
            // reference,
            ledger_account_id,
            gst_tin,
            state,
            currency,
            exchange_rate,
            fc_amount,
            amount,
            payment_by,
            payment_mode,
            cheque_date: chq_dd_date,
            cheque_number: chq_dd_no,
            // voucher_type,

            reference_number: reference_no,
            docket_number_or_order_number: job_order,
            shipper_name,
            bank_name,
            tds_rate,
            tds_account_name: tds_account,
            tds_party_name: tds_party,
            tds_amount,
            bank_charges: bank_charge,
            bank_amount,
            narration: remittance_narration,
            verified_by,
            date,
            book_total,
            total_tds,
            total_amount,
            total_tds_deducted,
            net_amount,
          }),
        },
      );

      const data = await response.json();

      if (response.ok) {
        toast.success(data?.msg || "Receipt Voucher created successfully");
        setReceiptVoucher(initialValue)
        setActiveTab("receipt_voucher");
        setIsSubmitting(false);
      } else {
        toast.error(data?.msg || "Failed to create receipt voucher");
        console.error("Server error:", data);
      }
    } catch (error) {
      console.error("Network error:", error);
      toast.error("Something went wrong while saving");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleSave = (e) => {
    e.preventDefault();
    createReceiptVoucherApi();
  };

  const onValueChange = (e) => {
    const { name, type, value, checked } = e.target;

    let finalValue = value;

    if (type == "number") {
      const testNum = Number(value);
      if (testNum <= 0) {
        finalValue = "";
      } else {
        finalValue = testNum;
      }
    }

    setReceiptVoucher((pre) => ({
      ...pre,
      [name]: type === "checkbox" ? checked : finalValue,
    }));
  };

  //currency change
  useEffect(() => {
    const testRev = MasterCurrencyIdAndName.find(
      (item) => item.id == receiptVoucher.currency,
    );

    setReceiptVoucher((prev) => ({
      ...prev,
      exchange_rate: testRev?.exchange_rate || 0,
    }));
  }, [receiptVoucher.currency]);

  //currency change
  useEffect(() => {
    const FcAmount = receiptVoucher.fc_amount || 0;
    const ExRate = receiptVoucher.exchange_rate || 0;

    // alert(FcAmount);
    const Amount = FcAmount * ExRate;

    setReceiptVoucher((prev) => ({
      ...prev,
      amount: Amount.toFixed(2),
    }));
  }, [receiptVoucher.exchange_rate, receiptVoucher.fc_amount]);

  //TDS amount change
  useEffect(() => {
    const tdsRate = receiptVoucher.tds_rate || 0;
    const amount = receiptVoucher.amount || 0;
    const bankCharge = receiptVoucher.bank_charge || 0;
    const bankAmount = receiptVoucher.bank_amount || 0;
    const tdsAmount = (tdsRate / 100) * amount;

    const fullTdxAmount = tdsAmount + bankCharge + bankAmount;
    const netAmount = amount - fullTdxAmount;

    setReceiptVoucher((prev) => ({
      ...prev,
      total_tds_deducted: fullTdxAmount.toFixed(2),
      tds_amount: tdsAmount.toFixed(2),
      net_amount: netAmount.toFixed(2),
    }));
  }, [
    receiptVoucher.tds_rate,
    receiptVoucher.amount,
    receiptVoucher.bank_charge,
    receiptVoucher.bank_amount,
  ]);

  //ledger account change
  useEffect(() => {
    const selectedLedger = LedgerAccountIdAndPartyName.find((item) => item.id == receiptVoucher.ledger_account_id)

    setReceiptVoucher((prev) => ({
      ...prev,
      ledger_account_name: selectedLedger?.name || "",
      gst_tin: selectedLedger?.ledger_gst || "",
      state: selectedLedger?.ledger_account_addresses[0].state || "",
    }));
  }, [receiptVoucher.ledger_account_id])

  useEffect(() => {
    if (token && user_id) {
      let invoice_id = generateCode();
      if (invoice_id) {
        setReceiptVoucher((pre) => ({
          ...pre,
          ["voucher_id"]: invoice_id,
        }));
      }
      dispatch(getAllMasterBranchIdAndName(token, user_id));
      dispatch(getAllMasterCashBookIdAndName(token, user_id));
      dispatch(getAllLedgerAccountIdAndPartyName(token, user_id));
      dispatch(getAllMasterCurrencyIdAndName(token, user_id));
    } else {
      toast.error("Please login to continue.");
      navigate(`/login?burl=${encodeURIComponent(q)}`);
    }
  }, [token, user_id, location.search]);

  return (
    <>
      <style>
        {`
        .padding-pt-9 {
           padding: 9px;
          }
        `}
      </style>
      <div className="card p-4">
        <h5 className="fw-semibold mb-3">Receipt Voucher Entry</h5>

        <form onSubmit={handleSave}>
          <div className="row">
            {/* voucher_number */}
            <div className="col-12 col-sm-6 col-md-4 mb-4">
              <label className="form-label fw-medium">
                Voucher Number<span className="text-danger">*</span>
              </label>
              <input
                type="text"
                name="voucher_number"
                className="form-control bg-light"
                placeholder="Auto-generated"
                disabled
                value={receiptVoucher.voucher_id}
              />
            </div>

            {/* voucher_date */}
            <div className="col-md-4 mb-4">
              <label className="form-label fw-medium">Voucher Date</label>
              <input
                type="date"
                name="voucher_date"
                className="form-control bg-light"
                placeholder="Enter to date"
                onChange={onValueChange}
                value={receiptVoucher.voucher_date}
              />
            </div>

            {/* branch */}
            <div className="col-md-4 mb-4">
              <label className="form-label fw-medium">Branch</label>
              <select
                name="branch"
                className="form-select bg-light padding-pt-9"
                value={receiptVoucher.branch}
                onChange={onValueChange}
              >
                <option value="">Select Branch</option>
                {MasterBranchName?.map((item, i) => (
                  <option value={item.id}>{item.name}</option>
                ))}
              </select>
            </div>

            {/* cost_centre */}
            <div className="col-md-4 mb-4">
              <label className="form-label fw-medium">Cost Centre</label>
              <select
                name="cost_centre"
                className="form-select bg-light padding-pt-9"
                value={receiptVoucher.cost_centre}
                onChange={onValueChange}
              >
                <option value="">Select Cost Centre </option>
                <option value="cost centre">cost centre 1</option>
              </select>
            </div>

            {/* cash_book_id */}
            <div className="col-md-4 mb-4">
              <label className="form-label fw-medium">Cash Book</label>
              <select
                name="cash_book_id"
                className="form-select bg-light padding-pt-9"
                value={receiptVoucher.cash_book_id}
                onChange={onValueChange}
              >
                <option value="">Select Cash Book </option>
                {MasterCashBookName?.map((item, i) => (
                  <option value={item.id}>{item.name}</option>
                ))}
              </select>
            </div>

            {/* current_balance */}
            <div className="col-md-4 mb-4">
              <label className="form-label fw-medium">Current Balance</label>
              <input
                type="number"
                name="current_balance"
                className="form-control bg-light "
                value={receiptVoucher.current_balance}
                onChange={onValueChange}
                placeholder="Current Balance"
              />
            </div>

            {/* reference_number */}
            <div className="col-md-4 mb-4">
              <label className="form-label fw-medium">Reference Number</label>
              <input
                type="text"
                name="reference_number"
                className="form-control bg-light "
                value={receiptVoucher.reference_number}
                onChange={onValueChange}
                placeholder="Reference Number "
              />
            </div>

            {/* ledger_account_id */}
            <div className="col-md-4 mb-4">
              <label className="form-label fw-medium">
                Ledger Account Name
              </label>
              <select
                name="ledger_account_id"
                className="form-select bg-light padding-pt-9"
                value={receiptVoucher.ledger_account_id}
                onChange={onValueChange}
              >
                <option value="">Select Ledger Account </option>
                {LedgerAccountIdAndPartyName?.map((item, i) => (
                  <option key={i} value={item.id}>
                    {item.ledger_party_name}
                  </option>
                ))}
              </select>
            </div>

            {/* gst_tin */}
            <div className="col-md-4 mb-4">
              <label className="form-label fw-medium">GST Tin </label>
              <input
                type="text"
                name="gst_tin"
                className="form-control bg-light "
                value={receiptVoucher.gst_tin}
                onChange={onValueChange}
                placeholder="GST Tin Number "
              />
            </div>

            {/* state */}
            <div className="col-md-4 mb-4">
              <label className="form-label fw-medium">State</label>
              {/* <select
                name="state"
                className="form-select bg-light padding-pt-9"
                value={receiptVoucher.state}
                onChange={onValueChange}
              >
                <option value="">Select state </option>
                <option value="state">state 1</option>
              </select> */}
              <input
                type="text"
                name="state"
                className="form-control bg-light "
                value={receiptVoucher.state}
                onChange={onValueChange}
                placeholder="State"


              />
            </div>

            {/* currency */}
            <div className="col-md-4 mb-4">
              <label className="form-label fw-medium">Currency</label>
              <select
                name="currency"
                className="form-select bg-light padding-pt-9"
                value={receiptVoucher.currency}
                onChange={onValueChange}
              >
                <option value="">Select Currency </option>
                {MasterCurrencyIdAndName?.map((item, i) => (
                  <option value={item.id}>{item.currency_name}</option>
                ))}
              </select>
            </div>

            {/* exchange_rate */}
            <div className="col-md-4 mb-4">
              <label className="form-label fw-medium">Exchange Rate</label>
              <input
                type="number"
                name="exchange_rate"
                className="form-control bg-light "
                value={receiptVoucher.exchange_rate}
                onChange={onValueChange}
                placeholder="Exchange Rate"
              />
            </div>

            {/* fc_amount */}
            <div className="col-md-4 mb-4">
              <label className="form-label fw-medium">FC Amount</label>
              <input
                type="number"
                name="fc_amount"
                className="form-control bg-light "
                value={receiptVoucher.fc_amount}
                onChange={onValueChange}
                placeholder="FC Amount "
              />
            </div>

            {/* amount */}
            <div className="col-md-4 mb-4">
              <label className="form-label fw-medium">Amount</label>
              <input
                type="number"
                name="amount"
                className="form-control bg-light "
                value={receiptVoucher.amount}
                onChange={onValueChange}
                placeholder="Amount"
              // disabled
              />
            </div>

            {/* payment_by */}
            <div className="col-md-4 mb-4">
              <label className="form-label fw-medium">Payment By</label>
              <input
                type="text"
                name="payment_by"
                className="form-control bg-light "
                value={receiptVoucher.payment_by}
                onChange={onValueChange}
                placeholder="Payment By "
              />
            </div>

            {/* payment_mode */}
            <div className="col-md-4 mb-4">
              <label className="form-label fw-medium">Payment Mode</label>
              <select
                name="payment_mode"
                className="form-select bg-light padding-pt-9"
                value={receiptVoucher.payment_mode}
                onChange={onValueChange}
              >
                <option value="">Select Payment Mode </option>
                <option value="Cash">Cash</option>
                <option value="Cheque">Cheque</option>
                <option value="DD">DD</option>
                <option value="NEFT">NEFT</option>
                <option value="RTGS">RTGS</option>
              </select>
            </div>

            {receiptVoucher.payment_mode === "Cheque" ||
              receiptVoucher.payment_mode === "DD" ? (
              <>
                {/* chq_dd_no */}
                <div className="col-md-4 mb-4">
                  <label className="form-label fw-medium">Chq/DD No</label>
                  <input
                    type="text"
                    name="chq_dd_no"
                    className="form-control bg-light "
                    value={receiptVoucher.chq_dd_no}
                    onChange={onValueChange}
                    placeholder="chq_dd_no "
                  />
                </div>

                {/* chq_dd_date */}
                <div className="col-md-4 mb-4">
                  <label className="form-label fw-medium">Chq/DD Date</label>
                  <input
                    type="date"
                    name="chq_dd_date"
                    className="form-control bg-light"
                    placeholder="Enter to date"
                    onChange={onValueChange}
                    value={receiptVoucher.chq_dd_date}
                  />
                </div>
              </>
            ) : null}
          </div>

          {/*form section two */}
          <div className="card p-4">
            <div className="row">
              {/* reference_no */}
              <div className="col-md-4 mb-4">
                <label className="form-label fw-medium">Reference No </label>
                <input
                  type="text"
                  name="reference_no"
                  className="form-control bg-light "
                  value={receiptVoucher.reference_no}
                  onChange={onValueChange}
                  placeholder="Reference No "
                />
              </div>

              {/* job_order  */}
              <div className="col-md-4 mb-4">
                <label className="form-label fw-medium">Job Order </label>
                <input
                  type="text"
                  name="job_order"
                  className="form-control bg-light "
                  value={receiptVoucher.job_order}
                  onChange={onValueChange}
                  placeholder="Job Order "
                />
              </div>

              {/* shipper_name  */}
              <div className="col-md-4 mb-4">
                <label className="form-label fw-medium">Shipper Name </label>
                <input
                  type="text"
                  name="shipper_name"
                  className="form-control bg-light "
                  value={receiptVoucher.shipper_name}
                  onChange={onValueChange}
                  placeholder="Shipper Name "
                />
              </div>

              {/* bank_name  */}
              <div className="col-md-4 mb-4">
                <label className="form-label fw-medium">Bank Name </label>
                <input
                  type="text"
                  name="bank_name"
                  className="form-control bg-light "
                  value={receiptVoucher.bank_name}
                  onChange={onValueChange}
                  placeholder="Bank Name "
                />
              </div>

              {/* tds_rate  */}
              <div className="col-md-4 mb-4">
                <label className="form-label fw-medium">Tds Rate </label>
                <input
                  type="number"
                  name="tds_rate"
                  className="form-control bg-light "
                  value={receiptVoucher.tds_rate}
                  onChange={onValueChange}
                  placeholder="TDS Rate "
                />
              </div>

              {/* tds_account  */}
              <div className="col-md-4 mb-4">
                <label className="form-label fw-medium">Tds Account </label>
                <input
                  type="text"
                  name="tds_account"
                  className="form-control bg-light "
                  value={receiptVoucher.tds_account}
                  onChange={onValueChange}
                  placeholder="TDS Account"
                />
              </div>

              {/* tds_party  */}
              <div className="col-md-4 mb-4">
                <label className="form-label fw-medium">Tds Party </label>
                <input
                  type="text"
                  name="tds_party"
                  className="form-control bg-light "
                  value={receiptVoucher.tds_party}
                  onChange={onValueChange}
                  placeholder="TDS Party"
                />
              </div>

              {/* tds_amount  */}
              <div className="col-md-4 mb-4">
                <label className="form-label fw-medium">Tds Amount </label>
                <input
                  type="number"
                  name="tds_amount"
                  className="form-control bg-light "
                  value={receiptVoucher.tds_amount}
                  onChange={onValueChange}
                  placeholder="TDS Amount"
                  disabled
                />
              </div>

              {/* bank_charge */}
              <div className="col-md-4 mb-4">
                <label className="form-label fw-medium">Bank Charge</label>
                <input
                  type="number"
                  name="bank_charge"
                  className="form-control bg-light"
                  value={receiptVoucher.bank_charge}
                  onChange={onValueChange}
                  placeholder="Bank Charge"
                />
              </div>

              {/* bank_amount */}
              <div className="col-md-4 mb-4">
                <label className="form-label fw-medium">Bank amount</label>
                <input
                  type="number"
                  name="bank_amount"
                  className="form-control bg-light"
                  value={receiptVoucher.bank_amount}
                  onChange={onValueChange}
                  placeholder="Bank Amount"
                />
              </div>
            </div>
          </div>

          {/* third section  */}
          <div className="card p-4">
            <div className="row">
              {/* remittance_narration */}
              <div className="col-12 col-sm-6 col-md-4 mb-4">
                <label className="form-label fw-medium">
                  Remittance Narration
                </label>
                <input
                  type="text"
                  name="remittance_narration"
                  className="form-control bg-light"
                  value={receiptVoucher.remittance_narration}
                  onChange={onValueChange}
                  placeholder="Remittance Narration"
                />
              </div>

              {/* verified_by */}
              <div className="col-12 col-sm-6 col-md-4 mb-4">
                <label className="form-label fw-medium">Verified By</label>
                <input
                  type="text"
                  name="verified_by"
                  className="form-control bg-light"
                  value={receiptVoucher.verified_by}
                  onChange={onValueChange}
                  placeholder="Verified By"
                />
              </div>

              {/* date */}
              <div className="col-12 col-sm-6 col-md-4 mb-4">
                <label className="form-label fw-medium"> Date</label>
                <input
                  type="date"
                  name="date"
                  className="form-control bg-light"
                  placeholder="Enter to date"
                  onChange={onValueChange}
                  value={receiptVoucher.date}
                />
              </div>

              {/* book_total */}
              {/* <div className="col-12 col-sm-6 col-md-4 mb-4">
                <label className="form-label fw-medium">book total</label>
                <input
                  type="text"
                  name="book_total"
                  className="form-control bg-light"
                  value={receiptVoucher.book_total}
                  onChange={onValueChange}
                  placeholder="book total"
                />
              </div> */}

              {/* total_tds */}
              {/* <div className="col-12 col-sm-6 col-md-4 mb-4">
                <label className="form-label fw-medium">total tds</label>
                <input
                  type="text"
                  name="total_tds"
                  className="form-control bg-light"
                  value={receiptVoucher.total_tds}
                  onChange={onValueChange}
                  placeholder="total tds"
                />
              </div> */}
            </div>
          </div>

          {/*vouchar Summary */}
          <div className="card p-4">
            <h5 className="fw-semibold mb-3">Voucher Summary</h5>
            <div className="d-flex justify-content-between">
              <h6 className="text-gray">Total Amount</h6>
              <h6 className="">₹ {receiptVoucher.amount}</h6>
            </div>
            <hr />
            <div className="d-flex justify-content-between">
              <h6 className="text-gray">Total TDS Deducted</h6>
              <h6>₹ {receiptVoucher.total_tds_deducted}</h6>
            </div>
            <hr />

            <div className="d-flex justify-content-between">
              <h6 className="">Net Amount</h6>
              <h6>₹ {receiptVoucher.net_amount}</h6>
            </div>
            <hr />

            {/* ACTION BUTTONS */}
            <div className="d-flex flex-wrap gap-2 mt-3">
              <button
                type="submit"
                className="btn btn-primary px-4"
                disabled={isSubmitting}
              >
                <i className="fas fa-save me-1"></i>
                {isSubmitting ? "Saving..." : "Save"}
              </button>

              {/* <button type="button" className="btn btn-light border px-4">
                Post Voucher
              </button>
              <button type="button" className="btn btn-light border px-4">
                Print
              </button>
              <button type="button" className="btn btn-light border px-4">
                Export PDF
              </button>
              <button type="button" className="btn btn-light border px-4">
                Delete
              </button> */}
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default VoucherProcessingReceiptVoucherEntryOne;
